import React, {useState, useContext} from "react";
import FutworkButton from "../../uicomponents/button";
import { removeAgentAssignedtoTL } from "./service"
import { TeamManagementContext } from "./teammanagementContext"
import styles from "../../assets/stylesheets/pages/teammanagement/teamlead.module.scss"

const RemoveAgent = (props) => {
    const { teamSelected } = useContext(TeamManagementContext)
    const [apiResponse, setApiResponse] = useState({
        status: '',
        msg: '',
        loading: false
    })
    const [retainAttendanceCriteria, setRetainAttendanceCriteria] = useState(false)
    
    const removeAgentFomTeam = async () => {
        setApiResponse(prev => ({ ...prev, loading: true }))
        
        try {
            const {id: teamLeadId} = teamSelected
            const payload = {
                agents: props.agents.map(agent => agent.id || agent), // Handle both object and ID cases
                teamLeadId,
                retain: retainAttendanceCriteria
            }

            const result = await removeAgentAssignedtoTL(payload)
    
            if(result && result.data){
                setApiResponse({
                    loading: false,
                    msg: result.data.msg,
                    status: 200
                })
            }

        } catch (error) {
            const {response: {data}} = error
            setApiResponse({
                status: 400,
                msg: data && data.error ? data.error : `Something went wrong`,
                loading: false
            })
        }
    }
    
    // Get agent name and team lead name for display
    const agentName = props.agents && props.agents.length > 0 ? 
        (props.agents[0].name || 'the agent') : 'the agent'
    const teamLeadName = teamSelected && teamSelected.teamName ? teamSelected.teamName : 'the team'
    
    return (
        <div>
            {apiResponse.msg ?
             apiResponse.status == 200 ? <div className={`${styles['success-msg']}`}>{apiResponse.msg}</div> :  apiResponse.status == 400 ? <div className={`${styles['error-msg']}`}>{apiResponse.msg}</div> : null
            : 
            <>
            <div className={styles.remove_agent_text}>
                <strong>Are you sure you want to remove {agentName} from {teamLeadName}?</strong>
            </div>
            <div style={{ marginTop: '15px', marginBottom: '20px', fontSize: '14px', color: '#666' }}>
                This action will unassign {agentName} from the team. You can choose to retain attendance-related criteria if applicable.
            </div>
            <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                    <input 
                        type="checkbox" 
                        checked={retainAttendanceCriteria}
                        onChange={(e) => setRetainAttendanceCriteria(e.target.checked)}
                        style={{ marginRight: '8px' }}
                    />
                    <span>Retain attendance criteria</span>
                </label>
            </div>
            <div className={styles.action_footer}>
                <FutworkButton 
                    buttonStyle={'danger--outline'} 
                    buttonSize={'medium'} 
                    onClick={props.close}
                    disabled={apiResponse.loading}
                >
                    Cancel
                </FutworkButton>
                <FutworkButton 
                    buttonStyle={'success--outline'} 
                    buttonSize={'medium'} 
                    onClick={() => removeAgentFomTeam()}
                    disabled={apiResponse.loading}
                >
                    {apiResponse.loading ? 'Removing...' : 'Remove'}
                </FutworkButton>
            </div>
            </>}
        </div>
    )
}

export default RemoveAgent